// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1IVVB","inner":"Footer_inner__3oBPM"};